import { render, staticRenderFns } from "./ReactivationAndReengagementModal.vue?vue&type=template&id=064c60ea&"
import script from "./ReactivationAndReengagementModal.vue?vue&type=script&lang=ts&"
export * from "./ReactivationAndReengagementModal.vue?vue&type=script&lang=ts&"
import style0 from "./ReactivationAndReengagementModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports